<template>
    <div class="table-footer">
        <div class="row">
            <div class="col-md-4">
                <span>Show</span>
                <select class="form-control" v-model="showPerPage" @change="showPerPageChanged()">
                    <option>10</option>
                    <option>25</option>
                    <option>50</option>
                    <option>100</option>
                </select>
                <span>Entries</span>
            </div>
            <div class="col-md-4 text-center" >
            </div>
            <div class="col-md-4 text-right">
                <a href="javascript:void(0)" v-if="currentPageNumber != 1" @click="getPreviousPageList()">Previous </a>
				<select
					class="form-control selectpicker"
					style = 'max-width:80px;'
					id="brandFilter"
					v-model="currentPageNumber"
					@change="getNewPageList()"
				>
					<option
						v-for="index in totalNoOfPages"
						:key="index"
						:value="index"
					>{{index}}</option>
				</select>
                <a href="javascript:void(0)" v-if="(showPerPage == issuesList.length && (currentPageNumber!=totalNoOfPages))" @click="getNextPageList()"> Next</a>
				<div style = "padding-right:0px;padding-top:5px">{{getCount()}}</div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name:'IssueListFooter',
    data() {
        return {
           	totalNoOfPages:1
        }
    },
    components: {
    },
	watch:{
		totalCount(){
			this.calculateIndexPerPage()
		}
	},
    computed: {
        showPerPage : {
            set(val) {
                return this.$store.state.productAlerts.showPerPage = val
            },
            get() {
                return this.$store.state.productAlerts.showPerPage
            }
        },
        totalCount : {
            set(val) {
                return this.$store.state.productAlerts.totalCount = val

            },
            get() {
                return this.$store.state.productAlerts.totalCount
            }

        },
        issuesList: {
            set(val) {
                this.$store.state.productAlerts.issuesList = val
            },
            get() {
                return this.$store.state.productAlerts.issuesList
            }
        },
        currentPageNumber: {
            set(val) {
                this.$store.state.currentPageNumber = val
            },
            get() {
                return this.$store.state.currentPageNumber
            }
        }
    },
    mounted(){
         this.calculateIndexPerPage()
    },
    methods: {
        calculateIndexPerPage(){
            this.totalNoOfPages=Math.ceil(this.totalCount/this.showPerPage)
        },
        getPreviousPageList() {
            if (this.currentPageNumber <= 1) {
                return
            }
            else {
                this.currentPageNumber -= 1
            }

            let partneruuid, marketplaceId
            if (this.$store.state.productAlerts.selectedAccount) {
                partneruuid = this.$store.state.productAlerts.selectedAccount.partneruuid
                marketplaceId = this.$store.state.productAlerts.selectedAccount.marketplace_id
            }
            const pageNumber = this.currentPageNumber
            const resultsPerPage = this.showPerPage
            const vm = this
            this.$store.dispatch("productAlerts/list", {...this.$store.state.productAlerts.issueFilters,partneruuid, marketplaceId, resultsPerPage, pageNumber}).then(res => {
                vm.$store.state.productAlerts.issuesList = res
            })
            
        },
        getNextPageList() {
            this.currentPageNumber += 1
            let partneruuid, marketplaceId
            if (this.$store.state.productAlerts.selectedAccount) {
                partneruuid = this.$store.state.productAlerts.selectedAccount.partneruuid
                marketplaceId = this.$store.state.productAlerts.selectedAccount.marketplace_id
            }
            const pageNumber = this.currentPageNumber
            const resultsPerPage = this.showPerPage
            const vm = this
            this.$store.dispatch("productAlerts/list", {...this.$store.state.productAlerts.issueFilters,partneruuid, marketplaceId, resultsPerPage, pageNumber}).then(res => {
                vm.$store.state.productAlerts.issuesList = res
            })
        },
		getNewPageList(){
            let partneruuid, marketplaceId
            if (this.$store.state.productAlerts.selectedAccount) {
                partneruuid = this.$store.state.productAlerts.selectedAccount.partneruuid
                marketplaceId = this.$store.state.productAlerts.selectedAccount.marketplace_id
            }
            const pageNumber = this.currentPageNumber
            const resultsPerPage = this.showPerPage
            const vm = this
            this.$store.dispatch("productAlerts/list", {...this.$store.state.productAlerts.issueFilters,partneruuid, marketplaceId, resultsPerPage, pageNumber}).then(res => {
                vm.$store.state.productAlerts.issuesList = res
            })
		},
		getCount(){
			let pageCount = this.showPerPage * (this.currentPageNumber - 1);
			let extendedcount = parseInt(pageCount)+ parseInt(this.issuesList.length);
            //return	pageCount+1 + ' to ' + extendedcount;
            return	'Showing ' + (pageCount+1) + ' to ' + extendedcount + ' results of ' + this.totalCount;
		},
        showPerPageChanged() {
			this.currentPageNumber = 1;
            let partneruuid, marketplaceId
            if (this.$store.state.productAlerts.selectedAccount) {
                partneruuid = this.$store.state.productAlerts.selectedAccount.partneruuid
                marketplaceId = this.$store.state.productAlerts.selectedAccount.marketplace_id
            }
            const pageNumber = this.currentPageNumber
            const resultsPerPage = this.showPerPage
            const vm = this
            this.$store.dispatch("productAlerts/list", {...this.$store.state.productAlerts.issueFilters,partneruuid, marketplaceId, resultsPerPage, pageNumber}).then(res => {
                vm.$store.state.productAlerts.issuesList = res
            })
		}
    }
        
}

</script>

<style lang="scss">

</style>
